import React from "react";
import { Container } from "@material-ui/core";

import css from "./Main.module.css";

import lakeImg from "../../assets/images/lake.jpg";
import childImg from "../../assets/images/child.jpg";
import cowsImg from "../../assets/images/cows.jpg";
import basilImg from "../../assets/images/basil.jpg";
import faucetImg from "../../assets/images/faucet.jpg";
import cleaningSuppliesImg from "../../assets/images/cleaning_supplies.jpg";
import pipeImg from "../../assets/images/pipe.png";
import withoutImg from "../../assets/images/without-aquavital.png";
import withImg from "../../assets/images/with-aquavital.png";
import mountImg from "../../assets/images/aquavital-mount.jpg";

import Section from "../../hoc/Section/Section";
import Title from "../UI/Title/Title";
import Banner from "../UI/Banner/Banner";
import List from "../UI/List/List";
import ImageWithText from "../UI/ImageWithText/ImageWithText";
import Button from "../UI/Button/Button";

const listItems = [
  "Bez gubitka vremena s montažom, nepotrebno rezanje vodovodnih cijevi",
  "Fizikalno vitaliziranje vode sa permanentnim magnetima",
  "Bez kemije",
  "Bez struje",
  "Bez troškova održavanja",
  "Originalni austrijski proizvod",
  "Već 18 godina u Hrvatskoj",
];

const Main = (props) => (
  <React.Fragment>
    <Title>{props.title}</Title>
    <Banner />
    <Container>
      <Button path="/kontakt">ZATRAŽITE BESPLATNU PROBU OD 30 DANA</Button>
    </Container>
    <br />
    <Section title="Osjetite razliku...">
      <List items={listItems} img={lakeImg} />
    </Section>
    <Section title="Vitalizirana voda...">
      <ImageWithText img={childImg} imgFirst>
        ...daje koži mekoću i voda ima osjetno bolji okus...
      </ImageWithText>
      <ImageWithText img={cowsImg}>
        ...prednost kod njegovanja životinja i boljeg uspjeha biljaka...
      </ImageWithText>
      <ImageWithText img={basilImg} imgFirst>
        ...kemijski spojevi se u njoj lakše rastvaraju, tako da štedimo kemijska
        sredstva i čuvamo okoliš.
      </ImageWithText>
    </Section>
    <Section title="Problemi sa kamencem...">
      <ImageWithText img={faucetImg} imgFirst>
        ...ubuduće pripadaju prošlosti
      </ImageWithText>
      <ImageWithText img={cleaningSuppliesImg}>
        Nema više agresivnih sredstava za čišćenje - štedite snagu, vrijeme i
        novac
      </ImageWithText>
    </Section>
    <Section title="Funkcionalnost">
      <div className={css.Functionality}>
        <Container maxWidth="md">
          <h4>Magnetni sistem spriječava taloženje vodenog kamenca...</h4>
          <img src={pipeImg} alt="pipeImage" />

          <p>
            Ukoliko pustimo vodu da teče kroz posebna magnetska polja kristali
            kamenca će promijeniti svoj oblik. Voda se putem te fizikalne
            reakcije dodatno vitalizira. U tako izmjenjenom stanju kristali
            kamenca ispiru se prolaskom tekuće vode, bez taloženja na stijenkama
            vodovodnih cijevi.
          </p>

          <h4>...i vitalizira vašu vodu</h4>
          <br />
          <hr />
          <br />
        </Container>
        <ImageWithText img={withoutImg} imgFirst>
          Tvrda voda pokazuje svoju grubu kristalnu strukturu kamenca. Govorimo
          o "Kalcitu"
        </ImageWithText>
        <ImageWithText img={withImg}>
          Djelovanjem magneta vidljivo sitnija struktura kamenca. Govorimo o
          "Aragonitu"
        </ImageWithText>
        <br />
        <Button path="/tipovi">SVI TIPOVI UREĐAJA</Button>
      </div>
    </Section>
    <Section title="Jednostavna montaža na glavnu cijev">
      <Container maxWidth="md">
        <img src={mountImg} alt="mountImg" />
      </Container>
    </Section>
  </React.Fragment>
);

export default Main;
